import injectSheet from 'react-jss'
import PopUp from './PopUp'
import styles from './PopUp.styles'

export default injectSheet(styles)(PopUp)
